var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-fluid mb-1 fixedmenuheader"},[_c('div',[_c('menu-type-admin')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }